export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9657.599d5f09.jpg";